import { useLayoutEffect, useRef, useState } from 'react'
import { Tooltip } from '@mui/material'

const TOOLTIP_PROPS = {
  tooltip: {
    sx: {
      backgroundColor: '#0C111D',
      padding: '12px',
      borderRadius: '8px',
      boxShadow: '0px 4px 6px -2px #10182808',
    },
  },
  arrow: { sx: { color: '#0C111D !important' } },
}

// Single-line text that ellipses when it overflows its parent, and reveals the
// full string in a tooltip on hover. The parent decides the max width — keep
// the surrounding container with `min-w-0` (or a fixed width) for `truncate`
// to actually clip.
export default function TruncatedText({
  text,
  children,
  tooltip,
  className = '',
  placement = 'top',
  as: Tag = 'span',
}) {
  const ref = useRef(null)
  const [truncated, setTruncated] = useState(false)
  const content = children ?? text
  const tooltipContent = tooltip ?? text ?? (typeof children === 'string' ? children : '')

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return undefined
    const check = () => setTruncated(el.scrollWidth > el.clientWidth + 1)
    check()
    const ro = new ResizeObserver(check)
    ro.observe(el)
    return () => ro.disconnect()
  }, [content])

  return (
    <Tooltip
      arrow
      placement={placement}
      title={truncated ? tooltipContent : ''}
      componentsProps={TOOLTIP_PROPS}
    >
      <Tag ref={ref} className={`block w-full truncate ${className}`}>
        {content}
      </Tag>
    </Tooltip>
  )
}
